import React from 'react';
import { foreclosureTxt } from "@/setting";
import { trackButtonClick } from '@/utils/analytics';

const ForeclosureSales = ({label}) => {
  return (
    <div className="pdpGenericContainer mb30">
      <div className="container">
        <div className="">
          <h4 className="propertyInfoBoxHeadingText p0">Foreclosure Sales</h4>
          <p className="pdpTextBlack">{label} {" "}
            <a
              className='text-decoration-underline learnMoreLink '
              style={{fontSize:16}}
              href={"https://www.hubzu.com/foreclosures"}
              target="_blank"
              onClick={() => {
                trackButtonClick({
                  eventName: "learn_more_foreclosure_sales",
                  eventCategory: "NEW-PDP",
                  eventSource: "on learn more click",
                });
              }}
            >
              Learn more
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForeclosureSales;